import React from 'react';

export const Tabs = ({ tabs, activeTab, onChange }) => (
  <div className="flex gap-1 mb-6 border-b border-slate-200/50">
    {tabs.map((tab) => (
      <button
        key={tab.value}
        className={`px-5 py-3 text-sm font-medium relative transition-colors font-sans border-none bg-transparent cursor-pointer
          ${activeTab === tab.value ? 'text-slate-800' : 'text-slate-500 hover:text-slate-700'}`}
        onClick={() => onChange(tab.value)}
      >
        {tab.label}
        {tab.count !== undefined && (
          <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 bg-slate-100 rounded-full text-xs ml-2">
            {tab.count}
          </span>
        )}
        {activeTab === tab.value && (
          <span className="absolute bottom-[-1px] left-0 right-0 h-0.5 bg-purple-500" />
        )}
      </button>
    ))}
  </div>
);
